import { ReactElement } from "react";
import { Box } from "@twilio-paste/core/box";
import { Text } from "@twilio-paste/core/text";
import {
  LegalStatementProps,
  ticketSubmissionViewCopy,
} from "@twiliointernal/org/twilio/e2-commons/shared/definitions";

const LegalStatement = ({ className }: LegalStatementProps): ReactElement => (
  <Box as="p" className={className}>
    <Text as="span" color="colorTextWeak" fontWeight="fontWeightBold">
      {ticketSubmissionViewCopy.oneSupportCenterForm.legal.part1}
    </Text>{" "}
    <Text as="span" color="colorTextWeak">
      {ticketSubmissionViewCopy.oneSupportCenterForm.legal.part2}
    </Text>
  </Box>
);

export default LegalStatement;
